import React from "react";
import { useSelector } from "react-redux";
import { pickBoardStories } from "../../../../redux/features/gameSlice";

import "./TodaysStoriesPreview.css";

const GAME_CATEGORY = "top-newsie"; // the board a player actually lands on first

// Only ever surfaces the puzzle's `emoji` + `clue` fields - never the real
// headline/description/link, which would give away the answer.
const TodaysStoriesPreview = (props) => {
  const { allNewsies } = props;
  // A topic link (e.g. /sports) previews that topic's clues instead
  const selectedNewsie = useSelector((state: any) => state.gameReducer.selectedNewsie);
  const category = allNewsies?.[selectedNewsie]?.length ? selectedNewsie : GAME_CATEGORY;
  // Same picks as the board, so the preview never shows a duplicate the game dropped
  const stories = pickBoardStories(allNewsies?.[category]).map((p) => p.story);

  if (!stories.length) {
    return (
      <div className="todays-stories-container">
        <div className="todays-stories-loading">Loading today's stories...</div>
      </div>
    );
  }

  return (
    <div className="todays-stories-container">
      <div className="todays-stories-heading">Today's Stories</div>
      <div className="todays-stories-list">
        {stories.map((story, i) => (
          <div className="todays-story-card" key={story.id || i}>
            <span className="todays-story-card-emoji">{story.emoji || "📰"}</span>
            <span className="todays-story-card-clue">{story.clue}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodaysStoriesPreview;
